module.exports = __webpack_public_path__ + "img/zoomed-BusinessTools-withwords.8f844de8.png";